export const APP_READY = "APP_READY" as const;
export const APP_INIT = "APP_INIT" as const;
export const TOGGLE_DARKMODE = "TOGGLE_DARKMODE" as const;

export interface AppState {
  readonly ready: boolean;
  readonly apiError: boolean;
  readonly isDarkMode?: boolean;
}

